import { Modal } from 'antd'
import styled from 'styled-components'

export const StyledModal = styled(Modal)`
  .ant-modal-content {
    border-radius: 16px;
    overflow: hidden;
    box-shadow: 0 14px 38px rgba(0, 0, 0, 0.18), 0 8px 20px rgba(0, 0, 0, 0.12);
  }
  .ant-modal-header {
    background: linear-gradient(135deg, #1a73e8 0%, #40a9ff 100%);
    border-bottom: none;
    padding: 16px 20px;
  }
  .ant-modal-title {
    color: #fff;
    font-weight: 700;
    letter-spacing: 0.2px;
  }
  .ant-modal-body {
    background: #f9fbff;
    padding: 22px 24px 8px 24px;
    font-size: 16px;
    line-height: 1.6;
    color: #2b2f36;
  }
  .ant-modal-footer {
    background: #f9fbff;
    border-top: none;
    padding: 12px 24px 24px 24px;
  }
  .ant-btn-primary {
    height: 40px;
    padding: 0 18px;
    border-radius: 10px;
    border: none;
    background-image: linear-gradient(135deg, #1677ff 0%, #3aa0ff 100%);
    box-shadow: 0 6px 16px rgba(64, 169, 255, 0.35);
    font-weight: 600;
  }
  .ant-btn-primary:hover,
  .ant-btn-primary:focus {
    filter: brightness(1.03);
    box-shadow: 0 8px 20px rgba(64, 169, 255, 0.45);
  }

  .warning-message{
    white-space: pre-wrap;
  }

  .link-renew{
    margin-top: 20px; 

    span{
      font-size: larger;
      cursor: pointer;
      text-decoration: underline;
      color: #1677ff;}
  }
`

export default StyledModal

